module.exports = __webpack_public_path__ + "433a961b8ed469c61b3824ff8cdb2510.pdf";